module.exports = __webpack_public_path__ + "img/37.a69b7e31.png";